
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '온니잡은 어떤 서비스인가요?',
      answer: '온니잡은 유흥업 전문 채용 플랫폼입니다. 급하게 인력이 필요한 사장님과 일자리를 찾는 구직자를 빠르고 안전하게 연결해드립니다.'
    }
  ];

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-4xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 bg-white rounded-full border border-gray-200 mb-6">
            <span className="text-sm font-medium text-gray-700" style={{ fontFamily: "'Pretendard', sans-serif" }}>자주 묻는 질문</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.02em' }}>
            궁금하신 점이 있으신가요?
          </h2>
          <p className="text-lg text-gray-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            자주 묻는 질문들을 모았습니다
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-300 cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-8" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-base text-gray-600 leading-relaxed" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 text-center">
          <p className="text-base text-gray-600 mb-6" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            더 궁금하신 점이 있으신가요?
          </p>
          <a
            href="https://pf.kakao.com/_xnxnxnxn"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-gray-900 text-white text-base font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Pretendard', sans-serif" }}
          >
            <i className="ri-kakao-talk-fill text-yellow-400"></i>
            카카오톡으로 문의하기
          </a>
        </div>
      </div>
    </section>
  );
}
